import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { useAuth } from '../context/AuthContext';

const QRScanPage = () => {
  const navigate = useNavigate();
  const { user: currentUser } = useAuth();

  const [feedback, setFeedback] = useState('Please scan the order QR code.');
  const [feedbackColor, setFeedbackColor] = useState('#666');
  const [isScanning, setIsScanning] = useState(true);
  const scannerRef = useRef(null);

  useEffect(() => {
    if (!isScanning) return;

    const onScanSuccess = async (scannedId, decodedResult) => {
      // Stop scanning immediately
      setIsScanning(false);
      
      if (scannerRef.current) {
        try {
          await scannerRef.current.clear();
        } catch (error) {
          console.error('Failed to clear scanner:', error);
        }
      }

      if (!currentUser || !currentUser.locationId) {
        setFeedback('Error: Your user profile is missing a location ID. Cannot verify QR code.');
        setFeedbackColor('red');
        return;
      }

      if (scannedId === currentUser.locationId) {
        setFeedback(`Success! Matched location ID: ${scannedId}. Redirecting...`);
        setFeedbackColor('green');
        setTimeout(() => {
          navigate(`/user/update-status/${scannedId}`);
        }, 1500);
      } else {
        setFeedback('Error: Scanned QR code does not match your location ID.');
        setFeedbackColor('red');
        setTimeout(() => {
          // Reset and restart scanning
          setFeedback('Scan failed. Please try again.');
          setFeedbackColor('#666');
          setIsScanning(true);
        }, 3000);
      }
    };

    const onScanFailure = (error) => {
      // ignore repeated decode errors
    };

    // Initialize scanner only when needed
    if (!scannerRef.current && isScanning) {
      scannerRef.current = new Html5QrcodeScanner(
        'qr-reader',
        { fps: 10, qrbox: { width: 250, height: 250 } },
        false
      );
      scannerRef.current.render(onScanSuccess, onScanFailure);
    }

    return () => {
      // Cleanup when component unmounts or when scanning stops
      if (scannerRef.current && !isScanning) {
        scannerRef.current.clear().catch((err) => console.error('Cleanup failed', err));
      }
    };
  }, [navigate, currentUser, isScanning]);

  const pageStyles = { display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '2rem', textAlign: 'center' };
  const feedbackStyles = { marginTop: '2rem', fontSize: '18px', fontWeight: 'bold', color: feedbackColor };

  return (
    <div style={pageStyles}>
      <h1>Scan Your Location QR Code</h1>
      {isScanning && (
        <div id="qr-reader" style={{ width: '100%', maxWidth: '500px', margin: '1rem auto' }}></div>
      )}
      <p style={feedbackStyles}>{feedback}</p>
    </div>
  );
};

export default QRScanPage;